// redux/root.reducer.js
import { combineReducers } from "redux";
import spaceReducer from "./space/space.reducer";
import userReducer from "./user/user.reducer";
import historyReducer from "./history/history.reducer";
import habitsReducer from "./habits/habits.reducer";
import notesReducer from "./notes/notes.reducer";
import tasksReducer from "./tasks/tasks.reducer";
import prjphasesReducer from "./prjphases/prjphases.reducer";
import prjtasksReducer from "./prjtasks/prjtasks.reducer";
import prjnotesReducer from "./prjnotes/prjnotes.reducer";
import filterReducer from "./filter/filter.reducer";
import meetsReducer from "./meeting/meeting.reducer";
import themeReducer from "./theme/theme.reducer";
import settingsReducer from "./settings/settings.reducer";
import videoCallReducer from "./videocall/videoCallSlice";
import filesReducer from "./files/files.reducer";

const rootReducer = combineReducers({
  space: spaceReducer,
  user: userReducer,
  history: historyReducer,
  habits: habitsReducer,
  notes: notesReducer,
  tasks: tasksReducer,
  prjphases: prjphasesReducer,
  prjtasks: prjtasksReducer,
  prjnotes: prjnotesReducer,
  filter: filterReducer,
  meets: meetsReducer,
  theme: themeReducer,
  settings: settingsReducer,
  videoCall: videoCallReducer,
  files: filesReducer,
});
export default rootReducer;
